<template>
  <div style="background:rgb(25, 118, 224,0.2);">
    <div class="container">
      <br /><br />
      <div class="row">
        <div class="col-md-2 col-lg-3 col-sm-1"></div>
        <div class="col-md-8 col-lg-6 col-sm-12">
          <div style="border-width: thin;background-color:white;">
            <h1 class="user-operation__title">Welcome back</h1>
            <el-form
              label-width="0"
              :model="loginFormModel"
              :rules="rules"
              ref="loginForm"
              class="user-operation__login-form"
            >
              <el-form-item class="loginPw is-required" prop="cellphone">
                <el-input
                  type="text"
                  placeholder="Login Name (Email)"
                  v-model="loginFormModel.cellphone"
                  @blur="inputBlurFn('cellphone')"
                ></el-input>
              </el-form-item>
              <el-form-item class="loginPw" prop="loginPassword">
                <el-input
                  type="password"
                  placeholder="Password"
                  v-model="loginFormModel.loginPassword"
                  :maxlength="16"
                  @blur="inputBlurFn('loginPassword')"
                ></el-input>
              </el-form-item>
              <el-form-item class="user-operation__login-bottom">
                  <el-button
                  class="el-button user-operation__login-submit el-button--primary"
                  type="primary"
                  :loading="isLogging"
                  @click.enter="submitForm"
                > <center>
                  Log In</center>
                </el-button>
                <div class="user-operation__login-links">
                  <router-link exact to="/forgot-password">
                    <span
                      style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;"
                    >
                      Forgot
                      your password?
                    </span>
                    <span style="color:#818a91;">Reset Password</span>
                  </router-link>

                  <router-link exact to="/get-start">
                    <span>Need an account?</span>
                    <span style="color:#818a91;">Get Start Now</span>
                  </router-link>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="col-md-2 col-lg-3 col-sm-1"></div>
      </div>
      <br />
      <br />
    </div>
  </div>
</template>
<script>
import placeholders from "../../scripts/placeholders";
import { mapGetters, mapActions } from "vuex";
import * as types from "../../vuex/types";
import api from "../../vuex/api";
import Cookie from "js-cookie";

export default {
  data() {
    // todo æŠ½å‡ºåŽ»ä¼šæŠ¥é”™ï¼Œtype = undefinedï¼ŒåŽŸå› ä¸�æ˜Žï¼Œå¾…æŸ¥
    const assignValidator = (type, trigger = "blur") =>
      Object.assign(
        {
          required: true,
          trigger
        },
        {
          validator: (rules, value, callback, source, options) => {
            this.$store.dispatch(type, {
              rules,
              value,
              callback,
              source,
              options
            });
          }
        }
      );
    return {
      isLogging: false,
      publicKey: "",
      verificationImageSrc: "",
      rules: {
        cellphone: [assignValidator(types.VERIFY_MOBILE)],
        loginPassword: [assignValidator(types.VERIFY_LOGIN_PASSWORD)],
        verificationCode: [
          {
            required: true,
            trigger: "blur",
            validator: (rules, value, callback, source, options) => {
              this.$store
                .dispatch(types.VERIFY_LOGIN_VERIFICATION_CODE, {
                  rules,
                  value,
                  callback,
                  source,
                  options
                })
                .then(res => {
                  if (res) {
                    // åŸºæœ¬å¡«å¯¹è€Œä¸”è¯·æ±‚ç»“æžœè¡¨ç¤ºé”™è¯¯
                    if (Number(res.data.code) === 1) {
                      this.refreshVerificationCode();
                    }
                  } else {
                    // æ²¡æœ‰æˆ�åŠŸè¯·æ±‚ï¼ŒéªŒè¯�å¤±è´¥
                    this.refreshVerificationCode();
                  }
                });
            }
          }
        ]
      },
      // è¦�ä¸�æ˜¯element uiçš„é™�åˆ¶ï¼Œformä¸�èƒ½æŽ¥æ”¶è®¡ç®—å±žæ€§ï¼Œé‚£ä¹ˆæ ¹æœ¬ä¸�åº”è¯¥æœ‰è¿™ä¸ªdata
      // åœ¨watché‡Œé�¢commit mutationä¼šå¯¼è‡´stateè¢«æ„�å¤–ä¿®æ”¹æŠ¥é”™
      loginFormModel: {
        cellphone: "",
        verificationCode: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL,
      companyInfo: types.GET_COMPANY_INFO
    })
  },
  methods: {
    ...mapActions({
      //userLogin: types.USER_LOGIN,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getGenerateRSAPublicKey: types.GET_GENERATE_RSA_PUBLIC_KEY
    }),
    refreshVerificationCode() {
      this.verificationImageSrc = `${
        this.ajaxBaseUrl
      }/servlet/ValidCode?rand=${new Date().getTime()}`;
    },
    submitForm() {
      var _this = this;
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          const form = this.loginFormModel;
          this.isLogging = true;
          const encrypt = new JSEncrypt();
          encrypt.setPublicKey(this.publicKey);
          const _loginPassword = encodeURI(encrypt.encrypt(form.loginPassword));

          api
            .userLogin({
              loginName: form.cellphone,
              password: form.loginPassword
            })
            .then(res => {
              this.isLogging = false;
              console.log(res)
              if (Number(res.data.code) === 0) {
                var data = res.data.data;
                var str = data.crmCustomerLoginName;
                if (str.indexOf("+1") >= 0) {
                  data.crmCustomerLoginName = str.slice(2);
                }
                Cookie.set(
                  "userData",
                  encodeURIComponent(JSON.stringify(data))
                );
                Cookie.set("customerId", data.crmCustomerId);

                setTimeout(function() {
                  _this.$router.push(data.crmCustomerType == '1' ? '/personalCenter' : '/brokerCenter');
                  window.location.reload(true);
                }, 10);
                
              } else {
                this.setAlertMessage({
                  show: true,
                  content: res.data.result || "login fail"
                });

                this.refreshVerificationCode();
              }
            });
        } else {
          setTimeout(() => {
            placeholders.placeHolder(this);
          }, 30);
          return false;
        }
      });
    },
    inputBlurFn(prop) {
      if (event.srcElement) {
        this.loginFormModel[prop] = event.srcElement.value;
        // this.loginFormModel[prop] = event.srcElement.value.substring(0,3)+'-'+event.srcElement.value.substring(3,6)+'-'+event.srcElement.value.substring(6);
      }
    }
  },
  mounted() {
    this.refreshVerificationCode();

    var seo = document.getElementById("seo")
    
    var meta=document.getElementById("seometa");
    if(!meta){
    meta=document.createElement("meta");
    meta.name="description";
    meta.id="seometa";
    document.head.insertBefore(meta,seo);
    }
    
    var keywords=document.getElementById("seokeywords");
    if(!keywords){
    keywords=document.createElement("meta");
    keywords.name="keywords";
    keywords.id="seokeywords"
    document.head.insertBefore(keywords,seo);
    }

    document.title="Login | American Credit"
    meta.content="Login to your American Credit account. See how fast we can fund you!";
    keywords.content="small business loan application, american credit";
  }
};
</script>
<style lang="scss">
.user-operation__login {
  @include userOperationBlockStyle;
  float: none;
  margin: 70px auto;
  padding: 20px;
  border-radius: 5px;
  overflow: hidden;
  width: 480px;
  box-shadow: 0 0 0.5rem rgba(21, 30, 52, 0.75);
  position: relative;
  z-index: 5;
}

.user-operation__login .is-required {
  width: 80%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.user-operation__title {
  @include clear;
  width: 100%;
  text-align: center;
  height: 50px;
  line-height: 50px;
  margin-bottom: 20px;
  background: rgb(3, 28, 200);
  font-family: "Museo";
  font-size: 18px;
  color: #fff;
  font-weight: normal;
  & img {
    float: left;
    line-height: 40px;
    font-size: 14px;
    //background: $trueBlack;
  }

  & span {
    float: left;
    margin-left: 16px;
    line-height: 40px;
    font-family: "MyriadPro-Regular";
    font-size: 20px;
    color: #999;
  }
}

.user-operation__login-form {
  padding: 25px;
  @include userOperationFormStyle;
}

.user-operation__login-bottom {
  margin-bottom: 0;
}

.user-operation__login-links {
  /*float: left;*/
  /*position: absolute;*/
  /*bottom: 0;*/
  color: $orange;
  font-family: "FZLanTingHei-DB-GBK";
  font-size: 12px;
  line-height: 1;

  & a {
    color: #2b66a0;
    position: relative;
    display: block;
    background-color: #fff;
    border-top: 1px solid #ddd;
    text-align: center;
    box-sizing: border-box;
    height: 60px;
    /*line-height:50px;*/
    transition: all ease 0.22s;
    padding: 10px 0;
    font-weight: normal;
    font-size: 12px;
  }

  & a:hover {
    background: #f5f5f5;
  }

  & a span {
    display: block;
    line-height: 20px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;
    font-size: 14px;
  }
}

.step-form__btn-container {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}

.user-operation__login-submit {
  float: right;
  border: 1px solid $orange;
  height: 45px;
  /*line-height: 45px;*/
  //letter-spacing: 18px;
  font-size: 14px;
  background: $orange;

  &:hover,
  &:focus,
  &:active {
    border: 1px solid $orange;
    background: $orange;
  }

  & span {
    //margin-right: -18px; // letter spacing fix
  }
}

.loginPw .el-input__icon.el-icon-loading {
  display: none;
}
</style>



// WEBPACK FOOTER //
// Login.vue?477c7dc6